// handleGreetings.js

import i18n from 'i18next';
import responses from './responses'; // Adjust the import path accordingly

export const handleGreetings = (lastMessage, t) => {
    // Get the current language
    const currentLanguage = i18n.language;
    console.log(`Current language: ${currentLanguage}`);

    // Get the current responses based on the language
    const currentResponses = responses[currentLanguage] || responses['en'];

    // Remove punctuation before comparing
    const cleanedText = lastMessage.text
        .replace(/[.,/#!$%^&*;:{}=_`~()"'<>?|+-]/g, '')
        .toLowerCase()
        .trim();

    let assistantMessage = null;

    if (currentResponses.greetings.includes(cleanedText)) {
        assistantMessage = {
            id: Date.now() + 1,
            type: 'assistant',
            text: currentResponses.responses.greeting,
        };
    } else if (currentResponses.goodbyes.includes(cleanedText)) {
        assistantMessage = {
            id: Date.now() + 1,
            type: 'assistant',
            text: currentResponses.responses.goodbye,
        };
    } else if (currentResponses.thankYous.includes(cleanedText)) {
        assistantMessage = {
            id: Date.now() + 1,
            type: 'assistant',
            text: currentResponses.responses.thankYou,
        };
    } else {
        assistantMessage = {
            id: Date.now() + 1,
            type: 'assistant_thinking',
            text: t('chat.thinkingPlaceholder'),
        };
    }

    return assistantMessage;
};
